import { message } from "antd";
import { FormLogin} from "../../components";
import "./login_styles.css";
import logo from "../../assets/img/logo.png"
import * as authService from "../../services/authService"

export const Login = () => {

  const handleLogin = async (values) => {
    try{
      const userData = await authService.signIn(values.username, values.password);
      message.success(`Bienvenido(a) ${userData.data().name} ${userData.data().surname}`);
    }catch(error){
      message.error(`Credenciales incorrectas`);
      console.log(error);
    }
  };

  return (
    <div className="login">
        {/* header */}
          <div className="login-header-container">
            {/* logo container */}
            <img src={logo} className="login-header-container-logo" alt="logo"/>
            <p className="login-header-container-text">Empieza a gestionar tus ventas en linea con nosotros.</p>
          </div>
        {/* login form container */}
          <div className="login-container">
            <div className="form-container">
              <FormLogin 
              handleLogin={handleLogin}
              />
            </div>
          </div>
    </div>
  );
};
